<div *ngIf="classCode">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>class</mat-icon>
      {{
        classCode.id ? "Class - " + classCode.name : "Create new Class"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ classCode.id ? "save" : "add" }}</mat-icon>
        {{ classCode.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="classCode.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Class Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="classCode.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="code"
                [model]="code"
                label="Code"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #code="ngModel"
                [(ngModel)]="classCode.code"
                required
                maxlength="10"
                id="code"
                name="code"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="classCode.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="classCode.description"
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="classCode.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="classCode.active === 'Y'" (change)="onCheckboxChange($event)" id="active" name="active">
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="notes"
                [model]="notes"
                label="Notes"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #notes="ngModel"
                [(ngModel)]="classCode.notes"
                required
                maxlength="200"
                id="notes"
                name="notes"
              />
            </td>
          </tr>
          
        </tbody>
      </table>
    </form>
  </div>
</div>
